import React from 'react';
import { useTranslation } from 'react-i18next';
import type { WorkflowInfo } from '../types/protocol';

interface QuickActionsProps {
  workflows: WorkflowInfo[];
  onActivate: (workflowId: string) => void;
  onFocusInput?: () => void;
}

function WorkflowIcon({ id }: { id: string }): React.ReactElement {
  if (id === 'campaign_setup') {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    );
  }
  // Default: lightning bolt
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  );
}

export function QuickActions({ workflows, onActivate, onFocusInput }: QuickActionsProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div className="sp-quick-actions">
      <div className="sp-quick-actions-header">
        <h3 className="sp-quick-actions-title">{t('quickActions.title')}</h3>
        <p className="sp-quick-actions-subtitle">
          {t('quickActions.subtitle')}
        </p>
      </div>
      <div className="sp-quick-actions-grid">
        {workflows.map((wf) => (
          <button
            key={wf.id}
            type="button"
            className="sp-quick-action-btn"
            onClick={() => onActivate(wf.id)}
          >
            <span className="sp-quick-action-icon">
              <WorkflowIcon id={wf.id} />
            </span>
            <span className="sp-quick-action-text">
              <strong>{wf.name}</strong>
              <span className="sp-quick-action-desc">{wf.description}</span>
            </span>
          </button>
        ))}
        <button
          type="button"
          className="sp-quick-action-btn sp-quick-action-chat"
          onClick={onFocusInput}
        >
          <span className="sp-quick-action-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </span>
          <span className="sp-quick-action-text">
            <strong>{t('quickActions.askQuestion')}</strong>
            <span className="sp-quick-action-desc">{t('quickActions.askDescription')}</span>
          </span>
        </button>
      </div>
    </div>
  );
}
